import { Component } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { FieldType, FormlyModule } from '@ngx-formly/core';
import { InputNumberModule } from 'primeng/inputnumber';

@Component({
    selector: 'app-quantity-number-input',
    templateUrl: './quantity-number-input.component.html',
    standalone: true,
    imports: [
        InputNumberModule,
        FormlyModule,
        ReactiveFormsModule,
    ]
})
export class QuantityNumberInputComponent extends FieldType {

}
